export const SORT = {
  alphabetically: 0,
  lastModified: 1,
  startDate: 2,
  tier: 3
};
